export default function getOnetimeSubtotalAmount({
  productType,
  productPriceAmount,
  totalTicketTypesAmount,
  quantity,
  oneTimeVariantsAmount,
  payWhatYouWantPrice,
  bulkDiscountAmount,
}) {
  if (productType === 'subscription') {
    return oneTimeVariantsAmount;
  } else {
    if (totalTicketTypesAmount) {
      if (bulkDiscountAmount) {
        return totalTicketTypesAmount - bulkDiscountAmount;
      } else {
        return totalTicketTypesAmount;
      }
    }

    let price = productPriceAmount;

    if (payWhatYouWantPrice) {
      price = payWhatYouWantPrice;
    }

    if (bulkDiscountAmount) {
      price = price * quantity - bulkDiscountAmount;
    } else {
      price = price * quantity;
    }

    if (oneTimeVariantsAmount) {
      price = price + oneTimeVariantsAmount;
    }

    return price;
  }
}
